var _defs, _path, _rect, _use, _use2, _line, _line2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneLaneRoadWithBicycleCrossing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "-100 -100 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "road-lines",
    d: "     M -100 0     L 120 0",
    stroke: "#FFF",
    strokeWidth: 1,
    strokeDasharray: "12 10",
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "     M -10 -100     L -10 -60     Q -10 -50 -20 -50     L -100 -50     L -100 50     L -20 50     Q -10 50 -10 60     L -10 100     L 10 100     L 10 60     Q 10 50 20 50     L 100 50     L 100 -50     L 25 -50     Q 10 -50 10 -60     L 10 -100",
    fill: "#707176"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 60,
    x: -100,
    y: -30,
    fill: "#3a4149"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#road-lines",
    transform: "translate(120,0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#road-lines",
    transform: "translate(-130,0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -10,
    x2: -10,
    y1: -27,
    y2: 27,
    stroke: "#FFF",
    strokeDasharray: "4 3",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10,
    y1: -27,
    y2: 27,
    stroke: "#FFF",
    strokeDasharray: "4 3",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50,-32) scale(0.5) rotate(-90)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 25,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 7,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "25,20 23,6 18,6 ",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "23.7,11 9,11 7,20 ",
    strokeLinecap: "butt"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8,-70) scale(0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 25,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 7,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "25,20 23,6 18,6 ",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "23.7,11 9,11 7,20 ",
    strokeLinecap: "butt"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50,-32) scale(0.5) rotate(-90)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 25,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 7,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "25,20 23,6 18,6 ",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "23.7,11 9,11 7,20 ",
    strokeLinecap: "butt"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8,-70) scale(0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 25,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 7,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "25,20 23,6 18,6 ",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "23.7,11 9,11 7,20 ",
    strokeLinecap: "butt"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLaneRoadWithBicycleCrossing);
export default __webpack_public_path__ + "static/media/one-lane-road-with-bicycle-crossing.aa8e2e909abc5afd00ff249a6896915d.svg";
export { ForwardRef as ReactComponent };